"use client";

import type { UseOpenApiMutationOptions } from "@packages/sdk";
import { useOpenApiMutation, useQueryClient } from "@packages/sdk";

import { keyMeRelatedAccounts } from "./useRequestMeRelatedAccounts";

const urlBackendPath = "/kids/{id}" as const;

export const useRequestKidsPatch = ({
  onSuccess,
  ...props
}: Partial<UseOpenApiMutationOptions<typeof urlBackendPath, "PATCH">> = {}) => {
  const queryClient = useQueryClient();

  return useOpenApiMutation({
    method: "PATCH",
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({ queryKey: keyMeRelatedAccounts() });
      onSuccess?.(data, variables, context);
    },
    urlBackendPath,
    ...props,
  });
};
